$.fn.addGridQueryParamsOnclick = function () {
  var DCLG = window.DCLG;
  var $DIALOG;
  var URLS = {};

  this.each(function () {
    var $self = $(this);

    if ($self.attr("href")) {
      // Dialog INIT
      if ($self.data("validate") === true) {
        // Init dialog popup
        $DIALOG = buildDialog({
          id: "download-csv-dialog",
          title: "Please note",
          buttons: [
            { type: "cancel", text: "No", extraClasses: "button-grey" },
            { type: "proceed", text: "Yes", extraClasses: "button" },
          ],
          buttonsAlign: "",
          colorScheme: "warning",
        });

        // Event handler for when confirmation dialog is used
        $("body").on("dialog.close.downloadcsv", $DIALOG, closeDialog);
      }

      $self.on("click", function (event) {
        if (isInTestDataStorePage()) {
          event.preventDefault();

          clearMessageInPage();


          URLS.destU = $self.attr("href");
          URLS.valU = "/submissions/test/allow-download.json";

          var sym = URLS.destU.indexOf("?") === -1 ? "?" : "&";

          var queryParams = DCLG.DataGrid.instance.dclg.params;
          if (!$.isEmptyObject(queryParams)) {
            URLS.destU = URLS.destU + sym + $.param(queryParams);
            URLS.valU += "?" + $.param(queryParams);
          }

          if ($self.data("validate") === true) {
            // Validate whether the download can proceed...
            validateDownload(URLS);
          } else {
            // Go ahead with the click.
            redirectTo(URLS.destU);
          }
        } else {
          event.preventDefault();

          clearMessageInPage();


          URLS.destU = $self.attr("href");
          URLS.valU = "/submissions/allow-download.json";

          var sym = URLS.destU.indexOf("?") === -1 ? "?" : "&";

          var queryParams = DCLG.DataGrid.instance.dclg.params;
          if (!$.isEmptyObject(queryParams)) {
            URLS.destU = URLS.destU + sym + $.param(queryParams);
            URLS.valU += "?" + $.param(queryParams);
          }

          if ($self.data("validate") === true) {
            // Validate whether the download can proceed...
            validateDownload(URLS);
          } else {
            // Go ahead with the click...
            redirectTo(URLS.destU);
          }
        }
      });
    }
  });

  function redirectTo(u) {
    window.location.href = u;
  }

  function buildDialog(builder) {
    var $dialog = $("#" + builder.id);

    if ($dialog) {
      // Title
      $dialog.find(".dialog-title").text(builder.title);

      // Buttons
      $.each(builder.buttons, function () {
        $dialog
          .find(".dialog-buttons button.dialog-" + this.type)
          .text(this.text)
          .addClass(this.extraClasses);
      });

      // Color Scheme
      $dialog
        .find(".icon.fa")
        .removeClass("fa-icontype")
        .addClass("fa-" + builder.colorScheme);

      // Event Handler for button-clicks
      $dialog.find(".dialog-buttons button").on("click", function (e) {
        e.preventDefault();

        // Event trigger for closing the dialog
        $dialog.trigger("dialog.close.downloadcsv", {
          button: e.target,
          destU: URLS.destU,
        });
      });
    }

    return $dialog;
  }

  function clearMessageInPage() {
    $("#message p").text("");
  }

  function showMessageInPage(msgType, msg) {
    var msgStyleColor = {};
    // Set CSS styles
    switch (msgType.toLowerCase()) {
      case "info":
        msgStyleColor.color = "blue";
      case "success":
        msgStyleColor.color = "green";
      case "warning":
        msgStyleColor.color = "orange";
      case "error":
      default:
        msgStyleColor.color = "red";
    }
    // Apply CSS style
    $("#message p").css(msgStyleColor).text(msg);
  }

  function closeDialog(e, trigger) {
    e.preventDefault();

    // Close the dialog
    e.target.close();

    // Remove indicators which show the dialog as being 'open'
    $("body").removeClass("dialog-is-open");

    // Decide whether to honour the DownloadCSV request, based on user feedback
    if ($(trigger.button).hasClass("dialog-proceed")) {
      console.log(
        "You chose to PROCEED with your Download*** request",
        trigger,
      );
      redirectToDownload(trigger.destU);
    } else {
    }
  }

  function isInDataStorePage() {
    return $("#datastore-page").length > 0;
  }

  function isInTestDataStorePage() {
    return $("#test-datastore-page").length > 0;
  }

  function downloadDatastoreFile() {
    var downloadButtons = $("#download-csv, #download-xml");
    $("#datastore-download-success-message").addClass("hidden");
    $("#datastore-download-error-message").addClass("hidden");
    $("#datastore-download-progress-container").removeClass("hidden");

    //update inset text
    $("#datastore-download-inset-text").html(
      "<p class='govuk-body'>The download can take several minutes to complete.<br>Do not refresh the page because this can cancel the download.</p>",
    );

    downloadButtons
      .addClass("govuk-button--disabled")
      .attr("disabled", "true")
      .attr("aria-disabled", "true")
      .attr("tabindex", "-1");

    $.ajax({
      url: "/submissions/datastore/download-file",
      xhrFields: {
        responseType: "blob",
      },
    }).done(function (file, status, response) {
      var contentDisposition = response.getResponseHeader("Content-Disposition");
      var filenameMatch = contentDisposition && contentDisposition.match(/filename="?([^";]+)"?/i);
      var objectUrl = URL.createObjectURL(file);
      var link = document.createElement("a");
      link.href = objectUrl;
      link.download = filenameMatch ? filenameMatch[1] : "datastore.zip";
      link.hidden = true;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(objectUrl);
      $("#datastore-download-inset-text").removeClass("hidden");
      $("#datastore-download-success-message").removeClass("hidden");
      $("#datastore-download-inset-text").html(
          "<p class='govuk-body'>Your data is now available for you to use.</p><p class='govuk-body'>If the downloaded data is not correct, you can change the filters and download the data again.</p>",
      );
    }).fail(function (jqXHR, textStatus, errorThrown) {
      $("#datastore-download-progress-container").addClass("hidden");
      // Show error banner and update guidance
      var $errorMessage = $("#datastore-download-error-message");
      $errorMessage.removeClass("hidden").focus();
      $("#datastore-download-inset-text").addClass("hidden");
    }).always(function () {
      $("#datastore-download-progress-container").addClass("hidden");
      downloadButtons
        .removeClass("govuk-button--disabled")
        .removeAttr("disabled")
        .removeAttr("aria-disabled")
        .removeAttr("tabindex");
    });
  }

  function redirectToDownload(url) {
    if (isInDataStorePage()) {
      $.ajax({
        dataType: "JSON",
        url: url,
      }).done(function (response) {
        $("#message").text("");
        if (response.name == "present")
          downloadDatastoreFile();
        else if (response.name == "largeFileDownload")
          redirectTo("/submissions/data-store/getting-file-ready");
        else $("#message").text(response.message.value);
      });
    } else if (isInTestDataStorePage()) {
      $.ajax({
        dataType: "JSON",
        url: url,
      }).done(function (response) {
        $("#message").text("");
        if (response.name == "present")
          redirectTo("/submissions/test/datastore/download-file");
        else $("#message").text(response.message.value);
      });
    } else redirectTo(url);
  }

  function showDialog(message) {
    // Add dialog message
    $DIALOG.find(".dialog-message").text(message);

    // Include indicators to show the dialog as being 'open'
    $("body").addClass("dialog-is-open");

    //  Now show the dialog...
    $DIALOG[0].showModal();
  }

  function validateDownload(URLS) {

    $.ajax({
      dataType: "JSON",
      url: URLS.valU,
    }).done(function (response) {
      if (
        response.hasOwnProperty("message") &&
        response.hasOwnProperty("allow")
      ) {

        if (response.allow === true) {
          if (!response.message.value) {
            // Continue as usual
            redirectToDownload(URLS.destU);
          } else {
            // Show confirmation dialog
            $("#download-csv-dialog")
              .find(".dialog-title")
              .text("Uncertified data");
            showDialog(response.message.value);
          }
        } else {
          if (response.message.type) {
            if (response.message.type == "error") {
              $("#message").css("color", "red").text(response.message.value);
            } else {
              showMessageInPage(response.message.type, response.message.value);
            }
          }
        }
      } else {
        if (response.hasOwnProperty("message")) {
          if (response.message.type) {
            // Display message in-page message and DO NOT proceed
            showMessageInPage(response.message.type, response.message.value);
          } else {
            showMessageInPage("error", response.message.value);
          }
        } else {
          console.log({
            error: "Badly-formed JSON response",
            data: response,
          }); // console.log error message display
        }
      }
    });
  }
};
